import { render } from "./BasicDetails.vue?vue&type=template&id=066c06b0"
import script from "./BasicDetails.vue?vue&type=script&lang=js"
export * from "./BasicDetails.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Projects\\KneeLeadNew\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__